import cn from 'classnames';
import { FC } from 'react';

import { type DayGroup } from '@/shared/config';

import { type TranscriptorConsultation } from '@/entities/transcriptor';

import { type RecordingRowActions } from '../../config';
import { RecordingRow } from '../RecordingRow';
import { RecordingsDayLabel } from '../RecordingsDayLabel';

import styles from './RecordingsTimeline.module.scss';

type RecordingsTimelineProps = {
  groups: DayGroup<TranscriptorConsultation>[];
  userTimezone: string;
  hideMode: boolean;
  className?: string;
  isConsultationStale: (consultation: TranscriptorConsultation) => boolean;
} & RecordingRowActions;

export const RecordingsTimeline: FC<RecordingsTimelineProps> = ({
  groups,
  userTimezone,
  hideMode,
  className,
  isConsultationStale,
  ...actions
}) => (
  <div
    className={cn(styles.timeline, className)}
    data-component="recordings-timeline"
  >
    {groups.map((group) => (
      <div
        key={group.dayKey}
        className={styles.group}
        data-component="recordings-day-group"
      >
        <RecordingsDayLabel date={group.dayDate} className={styles.dayLabel} />
        <div className={styles.marker}>
          <span className={styles.dot} />
        </div>
        <div className={styles.dayCard}>
          {group.items.map((consultation) => (
            <RecordingRow
              key={consultation.id}
              consultation={consultation}
              userTimezone={userTimezone}
              hideMode={hideMode}
              isStale={isConsultationStale(consultation)}
              {...actions}
            />
          ))}
        </div>
      </div>
    ))}
  </div>
);
